import React from 'react';

import Logo from '../../components/common/Logo/Logo.troy';
import Link from '../../components/common/Link';

import styles from './index.module.scss';
import logo from '../../assets/img/logos/troy/troy_footer.png';
import gitInfo from './git-info.json';


class Version extends React.Component {
  render() {
    return (
      <div className={styles['version__wrapper']}>
        <div>
          {(gitInfo && `hash: ${gitInfo.hash}`) || 'No data about hash'}
        </div>
        <div>
          {(gitInfo && `message: ${gitInfo.message}`) ||
            'No data about message'}
        </div>
        <Link id="page.version.component.version.home-link" to="/">
          <Logo src={logo} />
        </Link>
      </div>
    );
  }
}

export default Version;
